// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"7d451007","453":"5b5f864b","566":"58b91469"}[chunkId] + ".chunk.js";
};